// extracted by mini-css-extract-plugin
module.exports = {"select":"QuickInterval_select__2qPRc","menuItem":"QuickInterval_menuItem__p-gEN","every":"QuickInterval_every__27D_d"};